import React, { JSX, useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../../common/CmnContext';
import { LiveReserveContext } from '../../LiveLessonReseveContext';
import Modal from '../../../../../common/Modal';
import LiveReserveDateModal from './modal/LiveReserveDateModal';

import {
  formatDate, formatTime, formatTimeAddMin,
} from '../../../../../../util/utility';
import {
  isFilledLiveReserveRequestPrefs,
} from '../../../../../../models/lesson/live/reserve/request/LiveReserveRequest';


// 日時選択
function LiveReserveDate() {

  const { isPc } = useContext(cmnContext);
  const {
    lsnMin, calendar, selectedScheduleId,
    isLesson, isRequestMode, requestPrefs,
  } = useContext(LiveReserveContext);


  const [dispDate, setDispDate] = useState<string>('');
  const [dispDateTime, setDispDateTime] = useState<string>('');
  // モーダル表示
  const [isDispModal, setIsDispModal] = useState<boolean>(false);

  // SPEAKOUT-1853 希望日時（リクエスト）が3つとも入力済みか
  const isPrefsFilled = isFilledLiveReserveRequestPrefs(requestPrefs);
  // 入力済みか（枠を選んだ or 希望日時を入れた）
  const isDecided = isRequestMode ? isPrefsFilled : Boolean(selectedScheduleId);


  // 選択時にモーダルを閉じる
  useEffect(() => {
    setIsDispModal(false);
  }, [selectedScheduleId])


  // 予約日時
  useEffect(() => {
    for(const date in calendar) {
      const times = calendar[date];
      for(const time in times) {
        if(times[time] == selectedScheduleId) {
          setDispDate(formatDate(date));
          // 時間を"HH:MM"に整形
          setDispDateTime(`${formatTime(time)}〜${formatTimeAddMin(time, lsnMin)}`);
        }
      }
    }
  }, [calendar, selectedScheduleId])


  return (
    <>
      {/* ★id は「予約する」が押せないときのスクロール先（LiveReserveSubmit が使う） */}
      <div
        id="live_reserve_date"
        style={{
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'space-between',
          marginTop: '20px',
          marginBottom: '30px',
        }}>

          <div>
            <label className="control-label" style={{
              margin: '15px 0 10px 0',
              backgroundColor: '#eaffea',
              padding: '0.25em 3em 0.25em 0.5em',
              borderLeft: 'solid 5px #3c8c3c',
            }}>レッスンの日程</label>
            <div style={{marginLeft: '5px'}}>
              <p style={{
                margin: 0,
                fontSize: '16px',
                // バリデーションStyle
                ...(!isDecided ?
                  {
                    backgroundColor: 'red',
                    color: '#fff',
                    padding: '3px 10px',
                  }
                  : {}
                )
              }}>
                {isRequestMode ?
                  <>
                    {/* ★SPEAKOUT-1853 リクエストは第1〜第3希望をそのまま出す */}
                    {isPrefsFilled ?
                      requestPrefs.map((row: any, index: number) => (
                        <React.Fragment key={index}>
                          {index > 0 && <br />}
                          第{index + 1}希望&nbsp;{formatDate(row.date)}&nbsp;&nbsp;{row.start}〜{row.end}
                        </React.Fragment>
                      ))
                    :
                      <>希望日時を入力してください</>
                    }
                  </>
                :
                  <>
                    {(dispDate && dispDateTime) ?
                      <>{dispDate}&nbsp;&nbsp;{dispDateTime}</>
                    :
                      <>日程を選んでください</>
                    }
                  </>
                }
              </p>
            </div>
          </div>

          <div style={{marginRight: isPc? '5px':0}}>
            <button
              type="button"
              className='btn btn-success'
              style={{
                width: '100%',
                whiteSpace: 'normal',   // .btn は既定 nowrap＝長い文言が親からはみ出す
                margin: isPc? '10px 0 5px' : '5px 0 5px',
              }}
              onClick={() => setIsDispModal(true)}
            >
              {isRequestMode ?
                (isPrefsFilled ? '入れ直す' : '希望日時を入力')
              :
                (selectedScheduleId ? '選び直す' : '日程を選ぶ')
              }
            </button>
          </div>

        </div>

        {/* ★SPEAKOUT-1853 予約とリクエストのどちらになるかを日程欄で明示する。
            「予約したつもりがリクエストだった」という誤解を防ぐため、
            自動で切り替わったとき（枠が1つも無い）と、生徒が自分で選んだときで文言を変える。 */}
        {isRequestMode &&
          <div className="alert alert-warning" style={{padding: '8px 10px', marginTop: '-20px', marginBottom: '20px'}}>
            <small>
              {!isLesson ?
                <>
                  この講師・レッスン時間で予約できる空き枠が現在ありません。<br />
                </>
              :
                <>
                  空き枠以外の日時でのご希望として承ります。<br />
                </>
              }
              ご希望の日時を事務局へ<b>リクエスト</b>します（この時点では<b>予約は確定しません</b>）。
              事務局でご希望に沿った枠のご用意を調整のうえ、ご連絡いたします。
            </small>
          </div>
        }

        {/* 選択モーダル */}
        <Modal
          comp = {<LiveReserveDateModal setIsDispModal={setIsDispModal} />}
          isDispModal={isDispModal}
          setIsDispModal={setIsDispModal}
          isDispClose={true}
        />
    </>
  );
}

export default LiveReserveDate;
